import Vue from "vue";
import Vuex, { Store } from "vuex";
import { appHashCheckerPlugin, terratalkLivePlugin } from "@tt-app/store/_plugins";

import { RootStoreOptions, RootState } from "./root/types";
import { VUEX_USER_ACTION_NAMES, VUEX_USER_NAMESPACE } from "@tt-app/constants";
import { assignmentModule } from "@tt-app/store/assignment";
import { contentModule } from "@tt-app/store/content";
import { exerciseModule } from "@tt-app/store/exercise";
import { formModule } from "@tt-app/store/form";
import { historyModule } from "@tt-app/store/learningHistory";
import { terratalkLiveModule } from "@tt-app/store/terratalkLive";
import { userModule } from "@tt-app/store/user";
import { rootState as state } from "./root/state";
import { rootActions } from "./root/actions";
import { rootMutations } from "./root/mutations";
import { rootGetters } from "./root/getters";
import { releaseNotesModule } from "@tt-app/store/releaseNotes";

const { ALIASES_REQUEST, LOAD_USER_PROFILE } = VUEX_USER_ACTION_NAMES;

Vue.use(Vuex);

export const storeOptions: RootStoreOptions = {
  strict: !["production", "test", undefined].includes(process.env.NODE_ENV),

  state,
  actions: rootActions,
  mutations: rootMutations,
  getters: rootGetters,

  modules: {
    assignment: assignmentModule,
    content: contentModule,
    exercise: exerciseModule,
    form: formModule,
    learningHistory: historyModule,
    terratalkLive: terratalkLiveModule,
    user: userModule,
    releaseNotes: releaseNotesModule
  },

  plugins: [appHashCheckerPlugin, terratalkLivePlugin]
};

const store: Store<RootState> = new Vuex.Store<RootState>(storeOptions);

store.watch(
  (state: any) => {
    return state.user.authentication.token;
  },
  async newValue => {
    if (newValue) {
      await store.dispatch(`${VUEX_USER_NAMESPACE}/${ALIASES_REQUEST}`);
      await store.dispatch(`${VUEX_USER_NAMESPACE}/${LOAD_USER_PROFILE}`);
    } else {
      location.hash = "#/";
    }
  }
);

export default store;
